// Keep runtime URL acceptance aligned with this authoring contract.
export const LEGAL_NOTICE_TEXT_LIMIT = 600;
export function legalNoticeUrl(value) {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value.trim()) || value.length > 2048) return '';
  try {
    const url = new URL(value.trim());
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}
export function normalizeLegalNotice(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value) || typeof value.enabled !== 'boolean') throw new Error('Choose whether to show your notice and policy links.');
  if (typeof value.text !== 'string' || value.text.length > LEGAL_NOTICE_TEXT_LIMIT) throw new Error('Keep your notice to 600 characters or fewer.');
  if (!Array.isArray(value.links) || value.links.length > 3) throw new Error('Add up to three policy links.');
  const seen = new Set();
  const links = value.links.map(link => {
    if (!link || !['privacy', 'terms', 'additional'].includes(link.kind) || seen.has(link.kind)) throw new Error('Use one link for each policy.');
    seen.add(link.kind);
    const label = typeof link.label === 'string' ? link.label.trim() : '';
    const url = legalNoticeUrl(link.url);
    if (!label || label.length > 60) throw new Error('Give each policy link a label of 1–60 characters.');
    if (!url) throw new Error('Enter a full policy link starting with https:// or http://.');
    return {kind: link.kind, label, url};
  });
  return {enabled: value.enabled, text: value.text.trim(), links};
}
